import { CHANGE_LOGO } from './logo.actions'

const INITIAL_STATE = {
  imageSrc: null,
}

export function logoReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHANGE_LOGO:
      return { ...state, ...action.state }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/logo/logo.reducers.js